// import { Buffer } from 'buffer';
// import crypto from 'crypto-browserify';
// import { ALGO, IV, SECURITY } from './constants';
// export const encryption = (value) => {
// 	return new Promise((resolve) => {
// 		const ivBuf = Buffer.from(IV);
// 		const securityBuf = Buffer.from(SECURITY);
// 		console.log('securityBuf: ', securityBuf);
// 		console.log('ivBuf: ', ivBuf);
// 		const cipher = crypto.createCipheriv(ALGO, securityBuf, ivBuf);
// 		let cred = cipher.update(value, 'utf8', 'hex');
// 		cred += cipher.final('hex');

// 		resolve(cred);
// 	});
// };

import { IV, SECURITY } from './constants';

export const encryption = (value) => {
	return new Promise((resolve, reject) => {
		const encrypt = async () => {
			try {
				const encoder = new TextEncoder();

				// Convert to Uint8Array
				const ivBuf = encoder.encode(IV); // must be 16 bytes
				const securityBuf = encoder.encode(SECURITY); // must be 16/24/32 bytes depending on AES key size

				// Import key into Web Crypto
				const key = await window.crypto.subtle.importKey(
					'raw',
					securityBuf,
					{ name: 'AES-CBC' },
					false,
					['encrypt'],
				);

				// Perform encryption
				const encryptedData = await window.crypto.subtle.encrypt(
					{ name: 'AES-CBC', iv: ivBuf },
					key,
					encoder.encode(value),
				);

				// Convert ArrayBuffer to hex string
				const encryptedBytes = new Uint8Array(encryptedData);
				const hexString = Array.from(encryptedBytes)
					.map((b) => b.toString(16).padStart(2, '0'))
					.join('');

				resolve(hexString);
			} catch (err) {
				reject(err);
			}
		};

		encrypt();
	});
};
